import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';
import moment from 'moment';

const taskInfosHandlers = {
    [constant.taskInfos](state, action) {
        return action.payload;
    }
};

const loadingHandlers = {
    [constant.loading](state, action) {
        return action.payload;
    },
}

const urlHandlers = {
    [constant.url](state, action) {
        return action.payload;
    },
}

const searchHandlers = {
    [constant.search](state, action) {
        return { ...state, ...action.payload }
    }
};

export const loading = createReducer(false, loadingHandlers);
export const search = createReducer({ 'sBeginTime': moment().format('YYYY-MM-DD'), 'sEndTime': moment().format('YYYY-MM-DD') }, searchHandlers);
export const taskInfos = createReducer({}, taskInfosHandlers);
export const url = createReducer('', urlHandlers);

export const statisticsView = combineReducers({
    loading,
    search,
    taskInfos,
    url
})






// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/statistics-view/reducers.js